import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'
import { Dispatch, SetStateAction } from 'react'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { OVERALL_CATEGORY, PLANNING_BY_FY_FQ } from '../config'
import { IFieldProps } from '../models/IFieldProps'

import { getFieldName } from './getFieldName'
import { setFySobByQuarters } from './setFySobByQuarters'
import { setItemValuesUniversal } from './setItemValuesUniversal'

export interface ICalcSoBOverallForQuarter {
  items: IJBPPlanningItem[]
  categorySettings: IFormActualsTargetsSettings[]
  fieldProps: IFieldProps

  programType: string
  category: string
  fyear: number

  fy: number
  fq: number
  type: 'actuals' | 'targets'
  setActualsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>
  setTargetsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>

  currentFYear: number
  currentFQuarter: number

  isYearlyPlanning: boolean

  translationFactors?: ITranslationFactors[] | null
}

/**
 * Calc SoB Overall for Quarter by SubCategories
 */
export const calcSoBOverallForQuarter = ({
  items,
  categorySettings,
  fieldProps,

  programType,
  category,

  fy,
  fq,
  type,
  setActualsItems,
  setTargetsItems,

  currentFYear,
  currentFQuarter,

  translationFactors,
}: ICalcSoBOverallForQuarter) => {
  let data = [...items]

  //
  // Get Overall setting
  //
  const overallSettings = categorySettings.filter(
    (el) =>
      el.ProgramType === programType &&
      el.Category === category &&
      (!el.SubCategory || el.SubCategory === OVERALL_CATEGORY)
  )
  if (!overallSettings.length) {
    return data
  }
  const overallSetting = overallSettings[0]

  //
  // Get Fields names
  //
  const curFieldName = getFieldName({ ...fieldProps, isSoB: false })
  const sobFieldName = getFieldName(fieldProps)

  //
  // Get Overall data
  //
  // Filtered on Top level: PartnerId, ProgramTypes, Category, IsActuals, IsTarget, IsQuota
  const overData = items.filter(
    (el) =>
      el.ProgramTypes === overallSetting.ProgramType &&
      el.Category === overallSetting.Category &&
      el.FYear === fy &&
      el.FQuarter === fq &&
      el.SubCategory === overallSetting.SubCategory &&
      el.L3Category === overallSetting.L3Category
  )

  if (overData.length >= 1) {
    //
    // For all Subcategories in Category
    //
    let valTotal = 0
    let sobValTotal = 0
    for (let setIdx = 0; setIdx < categorySettings.length; setIdx++) {
      const subSet = categorySettings[setIdx]

      // Skip Overall category
      if (subSet.IsSoBAvailable && subSet.SubCategory && subSet.SubCategory !== OVERALL_CATEGORY) {
        const qData = items.filter(
          (el) =>
            el.ProgramTypes === overallSetting.ProgramType &&
            el.Category === overallSetting.Category &&
            el.FYear === fy &&
            el.FQuarter === fq &&
            el.SubCategory === subSet.SubCategory &&
            // For skip L3
            el.L3Category === subSet.L3Category
        )

        if (qData.length >= 1) {
          const curValue = Number(qData[0][curFieldName] || 0)
          const sobValue = Number(qData[0][sobFieldName] || 0)
          //console.log(`${subSet.SubCategory}: ${curValue} ${sobValue}`)
          if (curValue > 0 && sobValue > 0) {
            valTotal += curValue
            sobValTotal += curValue / sobValue
          }
        }
      }
    }

    // Set Actuals FY SoB for all not empty Actuals
    // Set Targets FY SoB if all quarters not empty

    if (sobValTotal) {
      const newOverSob = valTotal / sobValTotal

      const newItem = setItemValuesUniversal(
        overData[0],
        newOverSob,
        fieldProps,
        category,
        false,
        translationFactors
      )

      const idx = items.indexOf(overData[0])
      data.splice(idx, 1, newItem)

      if (type === 'actuals') {
        setActualsItems([...data])
      } else {
        setTargetsItems([...data])
      }

      //
      // Calc Overall FY
      //
      if (fq !== PLANNING_BY_FY_FQ) {
        data = setFySobByQuarters(
          data,
          overallSetting,
          fieldProps,
          fy,
          type,
          setActualsItems,
          setTargetsItems,
          currentFYear,
          currentFQuarter,
          null
        )
      }
    }
  }

  return data
}
